module.exports = __webpack_public_path__ + "static/media/AI_11.99491874.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/AI_11.png
// module id = 126
// module chunks = 0